export default __webpack_public_path__ + "static/media/helmetOne.2af83873.png";